module.exports = __webpack_public_path__ + "img/howto_ico02.6014b751.png";